export interface BugReportErrorContext {
  occurredAt: string;
  status: number;
  method?: string;
  requestPath?: string;
  pagePath?: string;
  responseCode?: string;
  responseTitle?: string;
  responseMessage?: string;
  responseType?: string;
  requestId?: string;
  traceId?: string;
  correlationId?: string;
}

export const BUG_REPORT_ERROR_CONTEXT_FIELDS: {key: keyof BugReportErrorContext; label: string}[] = [
  {key: 'occurredAt', label: 'bug_report.error_context.occurred_at'},
  {key: 'status', label: 'bug_report.error_context.status'},
  {key: 'method', label: 'bug_report.error_context.method'},
  {key: 'requestPath', label: 'bug_report.error_context.request_path'},
  {key: 'pagePath', label: 'bug_report.error_context.page_path'},
  {key: 'responseCode', label: 'bug_report.error_context.response_code'},
  {key: 'responseTitle', label: 'bug_report.error_context.response_title'},
  {key: 'responseMessage', label: 'bug_report.error_context.response_message'},
  {key: 'responseType', label: 'bug_report.error_context.response_type'},
  {key: 'requestId', label: 'bug_report.error_context.request_id'},
  {key: 'traceId', label: 'bug_report.error_context.trace_id'},
  {key: 'correlationId', label: 'bug_report.error_context.correlation_id'}
];
